import { dateRangeBoundsSchema } from 'lib/dateRangeBoundsSchema'
import { z } from 'zod'

export const filtersSchema = z.object({
  timeRange: z.object({
    dateRange: dateRangeBoundsSchema,
  }),
  workId: z.object({
    id: z.number().nullable(),
  }),
  shiftId: z.object({
    id: z.number().nullable(),
  }),
  companyId: z.object({
    id: z.number().nullable(),
  }),
  companyGroupId: z.object({
    id: z.number().nullable(),
  }),
  workerId: z.object({
    id: z.number().nullable(),
  }),
})

export type FiltersSchema = z.infer<typeof filtersSchema>
